import request from 'Request'
import { updateEncounter } from 'Store/encounters'

const EventService = {
  async get({ eventId }) {
    return request.get('/events/get', { params: { eventId } })
  },
  async list({ encounterId }) {
    return request.post('/events/list', {
      encounterId
    })
  },
  async create({ type, event, data, encounterId }) {
    // TODO: This is not needed when websocket is fixed on dev/stage
    updateEncounter(encounterId)
    return request.put('/events/create', {
      type,
      event,
      data,
      encounterId
    })
  }
}

export default EventService
